import React from "react";
import { formatDate, addCommasNumbers } from "../utilities/utils";

const ActionDetailModal = ({ show, onHide, actionDetails }) => {
    if (!show) return null;

  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      data-backdrop="static"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div className="modal-dialog"  role="document">
        <div
          className="modal-content modal"
        >
          {/* Header START */}
          <div
            className="modal-header headerModals"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              backgroundColor: "#64748b",
              color: "#fff",
            }}
          >
            <h5 className="modal-title">Action Details</h5>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={onHide}
            >
              <span aria-hidden="true" style={{ color: "#fff" }}>
                &times;
              </span>
            </button>
          </div>
          {/* Header END */}

          {/* Body START */}
          <div
            className="modal-body"
            style={{
                overflowY: "auto",
                maxHeight: "400px",
                backgroundColor: "#f8f9fa",
            }}
            >
            <table className="table table-striped table-sm">
                <thead className="thead-light">
                <tr>
                    <th style={{ width: "40%" }}>Date</th>
                    <th style={{ width: "40%" }}>Action</th>
                    <th style={{ width: "20%" }}>Amount</th>
                </tr>
                </thead>
                <tbody>
                {actionDetails && actionDetails.length > 0 ? (
                    actionDetails.map((detail, index) => (
                    <tr key={index}>
                        <td>{formatDate(detail?.ActionDateTime) || "N/A"}</td>
                        <td>{detail?.WActionDescription || "N/A"}</td>
                        <td>{addCommasNumbers(detail?.Amount?.toFixed(2)) || "0.00"}</td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="3" style={{ textAlign: "center", fontStyle: "italic" }}>
                        No information available
                    </td>
                    </tr>
                )}
                </tbody>
            </table>
            </div>
          {/* Body END */}

          {/* Footer START */}
          <div
            className="modal-footer"
            style={{
              position: "sticky",
              bottom: 0,
              zIndex: 10,
              backgroundColor: "#fff",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onHide}
            >
              Close
            </button>
          </div>
          {/* Footer END */}
        </div>
      </div>
    </div>
  );
};

export default ActionDetailModal;
